module.exports = __webpack_public_path__ + "static/century-complete-zoom-ff3c5799f1454c70d80465d70dfabe6a.jpg";